// eslint-disable-next-line import/prefer-default-export
export const ORCID_USER_COLOR = "#008004";
